<table
  data-test="4i3M_QdO"
  class="document__table items-table items-table_light"
  *ngIf="items?.length"
>
  <tr data-test="eC3yK7wa">
    <th data-test="kaFsqUkm"></th>
    <th data-test="f88SiLXa" class="text-right" style="width: 10%" *ngIf="showCosts">
      Cost breakdown
    </th>
    <th data-test="Vxmp4aeQ" class="text-right" style="width: 10%">Billable breakdown</th>
    <th data-test="PNaOPg6-" class="text-right" style="width: 5%" *ngIf="showCosts"></th>
  </tr>

  <tr
    data-test="euxFbEPO"
    *ngFor="let item of items; index as i"
    [ngClass]="{ 'row-bg': i % 2 === 0 }"
  >
    <td data-test="26Qg-FGJ" [ngClass]="{ h3: item.isTotal }">
      <b data-test="xtt5hJUg">{{ item.title }}</b>
    </td>
    <td
      data-test="WeDl3pRe"
      *ngIf="showCosts"
      class="text-right"
      [ngClass]="{ h3: item.isTotal }"
    >
      <span data-test="BEn4gUmu" class="text-light">{{ currencySign }}</span>
      {{ item.cost | fromCents | companyCurrency }}
    </td>

    <td
      data-test="eT8mDGzh"
      class="text-right pr-2"
      [ngClass]="{ h3: item.isTotal }"
      style="border-right: none"
    >
      <span data-test="qvb1G8FS" class="text-light">{{ currencySign }}</span>
      {{ item.total | fromCents | companyCurrency }}
    </td>
    <td
      data-test="wwAG_ZRJ"
      *ngIf="showCosts"
      style="border-left: none"
      [ngClass]="{ h3: item.isTotal }"
    >
      <span data-test="-cDjQSqY" class="text-light">
        ({{ calculateMargin(item.total, item.cost) }}%)
      </span>
    </td>
  </tr>
</table>
